import * as React from "react";
import "../staff/NewStaff.scss";
import "./NewRole.scss"
import HandleUIError from "../../utils/HandleUIError";
import toast from "react-hot-toast";

//components
import {
  Modal,
  Input,
  Button,
  Spinner,
  IconButton,
} from "../Atomics";
import { cilX } from "@coreui/icons";
import { saveParents } from "../../services/rolesService";

interface Props {
  visible: boolean;
  closeModal: () => void;
  refreshParents: () => void;
}

const NewRole: React.FC<Props> = ({ visible, closeModal, refreshParents}) => {
  const [name, setName] = React.useState<string>("");
  const [email, setEmail] = React.useState<string>("");
  const [phone, setPhone] = React.useState<string>("");
  const [addParentLoading, setAddParentLoading] = React.useState<boolean>(false);

  const handleInputName = (e: any) => {
    setName(e.target.value);
  };
  
  const handleInputMail = (e: any) => {
    setEmail(e.target.value);
  };
  
  const handleInputPhone = (e: any) => {
    setPhone(e.target.value);
  };

  async function addParent(name: string, email: string, phone: string): Promise<void> {
    setAddParentLoading(true);
      try {
        if(name === "" || name === null){
          toast.error("Name cannot be empty")
          setAddParentLoading(false);
        }else{
          await saveParents(name, email, phone);
          await refreshParents();
          toast.success("Role added");
          setAddParentLoading(false);
          onCloseModal();
        }
      } catch (e) {
        setAddParentLoading(false);
        HandleUIError(e);
      }
  }

  function onCloseModal() {
    setName("");
    setEmail("");
    setPhone("");
    closeModal();
  }

  return (
    <Modal visible={visible} >
      <div className="new-staff-container h-auto">
        <div className="new-staff-header">
          <p className="text-light py-2 ps-4 fs-5">Add new Role ddd</p>
          <IconButton icon={cilX} className="me-3" onClick={closeModal} />
        </div>
      
          <div className="mt-5">
            <p className="text-light fs-5 ms-3 pt-3">
              Name
            </p>
            <Input
              className="mt-2 mb-3 ms-3 search-phone-input"
              onChange={handleInputName}
              autoFocus
              maxLength={20}
            />
            <Button
              disabled={addParentLoading}
              className="mt-7 button-add px-4 mb-3"
              onClick={() => addParent(name, email, phone)}
            >
              {!addParentLoading ? "Add" : <Spinner />}
            </Button>
          </div>
      </div>
    </Modal>
  );
};

export default NewRole;
